import React, { useState } from "react";

const Facebook = () => {
  const [canonicalText, setCanonicalText] = useState("");
  const [canonicalEntries, setCanonicalEntries] = useState([]);

  const handleTextareaChange = (event) => {
    setCanonicalText(event.target.value);
  };

  const handleSubmit = () => {
    if (canonicalText.trim() !== "") {
      setCanonicalEntries([...canonicalEntries, canonicalText]);
      setCanonicalText(""); // Clear the textarea
    }
  };

  const handleDelete = (index) => {
    // Create a copy of canonicalEntries without the entry at the specified index
    const updatedEntries = [...canonicalEntries];
    updatedEntries.splice(index, 1);
    setCanonicalEntries(updatedEntries);
  };

  return (
    <section>
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12 mt-3 mb-3">
            <div className="row">
              <div className="col-lg-5">
                <h4>SEO</h4>
              </div>
            </div>

            <div className="row">
              <div className="card border-0 shadow ">
                <div className="card-header bg bg-info border-0">
                  <h4>Facebook Pixel</h4>
                </div>

                <div className="card-body ">
                  <div className="col-lg-10 ">
                    <div class="row mb-3">
                      <div class="col-sm-3">
                        <h6 class="mb-0"> Facebook Pixel </h6>
                      </div>
                      <div class="col-sm-9 text-secondary">
                        <textarea
                          id=""
                          name=""
                          rows="6"
                          class="form-control"
                          value={canonicalText}
                          onChange={handleTextareaChange}
                        ></textarea>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-sm-3"></div>
                      <div class="col-sm-9 text-secondary">
                        <input
                          type="button"
                          class="btn btn-primary px-4"
                          value="Submit"
                          onClick={handleSubmit}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="card border-0 shadow ">
                <div className="card-header bg bg-info border-0">
                  <h4>Facebook Pixel Code</h4>
                </div>

                <div class="card-body">
                  <div class="table-responsive">
                    <div
                      id="example2_wrapper"
                      class="dataTables_wrapper dt-bootstrap5 no-footer"
                    >
                      <div class="row">
                        <div class="col-sm-12 col-md-6">
                          <div class="dt-buttons btn-group">
                            {" "}
                            <button
                              class="btn btn-outline-secondary buttons-copy buttons-html5"
                              tabindex="0"
                              aria-controls="example2"
                              type="button"
                            >
                              <span>Copy</span>
                            </button>{" "}
                            <button
                              class="btn btn-outline-secondary buttons-excel buttons-html5"
                              tabindex="0"
                              aria-controls="example2"
                              type="button"
                            >
                              <span>Excel</span>
                            </button>{" "}
                            <button
                              class="btn btn-outline-secondary buttons-pdf buttons-html5"
                              tabindex="0"
                              aria-controls="example2"
                              type="button"
                            >
                              <span>PDF</span>
                            </button>{" "}
                            <button
                              class="btn btn-outline-secondary buttons-print"
                              tabindex="0"
                              aria-controls="example2"
                              type="button"
                            >
                              <span>Print</span>
                            </button>{" "}
                          </div>
                        </div>
                        <div class="col-sm-12 col-md-6">
                          <div id="example2_filter" class="dataTables_filter">
                            <label>
                              Search:
                              <input
                                type="search"
                                class="form-control form-control-sm"
                                placeholder=""
                                aria-controls="example2"
                              />
                            </label>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-12">
                          <table
                            id="example2"
                            class="table table-striped table-bordered dataTable no-footer"
                            role="grid"
                            aria-describedby="example2_info"
                          >
                            <thead>
                              <tr role="row">
                                <th
                                  class="sorting_asc"
                                  tabindex="0"
                                  aria-controls="example2"
                                  rowspan="1"
                                  colspan="1"
                                  aria-sort="ascending"
                                  aria-label="Sl No: activate to sort column descending"
                                  
                                >
                                  Sl No
                                </th>
                                <th
                                  class="sorting"
                                  tabindex="0"
                                  aria-controls="example2"
                                  rowspan="1"
                                  colspan="1"
                                  aria-label=" Site Verification Code : activate to sort column ascending"
                                 
                                >
                                  {" "}
                                  Facebook Pixel Code{" "}
                                </th>
                                <th
                                  class="sorting"
                                  tabindex="0"
                                  aria-controls="example2"
                                  rowspan="1"
                                  colspan="1"
                                  aria-label="Action: activate to sort column ascending"
                                  
                                >
                                  Action
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                            {canonicalEntries.map((entry, index) => (
                              <tr role="row" class="odd">
                              <td>{index + 1}</td>
                                <td>{entry}</td>
                                <td>
                                  <button type="button" class="btn btn-danger" onClick={() => handleDelete(index)}>
                                    Delete
                                  </button>
                                </td>
                              </tr>
                               ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Facebook;
